import { Component, Input } from '@angular/core';

@Component({
  selector: 'om-svg-preferred-pharmacy',
  template: `
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.07422 21.7686V21.4609C1.07422 20.9087 1.52193 20.4609 2.07422 20.4609H24.0742C24.6265 20.4609 25.0742 20.9087 25.0742 21.4609V21.7686C25.0742 22.3209 24.6265 22.7686 24.0742 22.7686H2.07422C1.52193 22.7686 1.07422 22.3209 1.07422 21.7686Z"
        fill="white"
        stroke="#005450"
      />
      <path d="M2.38281 16.1328H21.7674" stroke="#005450" />
      <path
        d="M2.38281 19.4615V9C2.38281 8.44772 2.83053 8 3.38281 8H20.7674C21.3197 8 21.7674 8.44771 21.7674 9V19.4615C21.7674 20.0138 21.3197 20.4615 20.7674 20.4615H3.38281C2.83053 20.4615 2.38281 20.0138 2.38281 19.4615Z"
        fill="white"
        stroke="#005450"
      />
      <path
        d="M1 9.76893V6.23047C1 5.67818 1.44771 5.23047 2 5.23047H22.1538C22.7061 5.23047 23.1538 5.67818 23.1538 6.23047V9.76893C23.1538 10.3212 22.7061 10.7689 22.1538 10.7689H2C1.44772 10.7689 1 10.3212 1 9.76893Z"
        fill="white"
        stroke="#005450"
      />
      <path
        d="M16.457 14.7695V19.2306C16.457 19.7829 16.9047 20.2306 17.457 20.2306H19.1491C19.7014 20.2306 20.1491 19.7829 20.1491 19.2306V14.7695C20.1491 14.2172 19.7014 13.7695 19.1491 13.7695H17.457C16.9047 13.7695 16.457 14.2172 16.457 14.7695Z"
        fill="#C9EEE5"
        stroke="#005450"
      />
      <path d="M19.4609 16.0781V17.2319" stroke="#005450" stroke-linecap="round" />
      <path
        d="M3.76562 17.3849V14.7695C3.76562 14.2172 4.21334 13.7695 4.76562 13.7695H13.8425C14.3948 13.7695 14.8425 14.2172 14.8425 14.7695V17.3849C14.8425 17.9372 14.3948 18.3849 13.8425 18.3849H4.76562C4.21334 18.3849 3.76562 17.9372 3.76562 17.3849Z"
        fill="#C9EEE5"
        stroke="#005450"
      />
      <circle cx="11.7663" cy="5.69204" r="3.31704" fill="white" stroke="#005450" stroke-width="0.75" />
      <rect
        x="9.92643"
        y="4.75736"
        width="1.79943"
        height="3.93924"
        rx="0.899716"
        transform="rotate(-40.0029 9.92643 4.75736)"
        fill="#005450"
        stroke="#005450"
        stroke-width="0.5"
      />
      <path
        d="M10.5048 5.44655C10.1854 5.06592 10.235 4.49842 10.6156 4.179C10.9963 3.85958 11.5638 3.9092 11.8832 4.28983L12.6803 5.23972L11.3019 6.39644L10.5048 5.44655Z"
        fill="#C9EEE5"
        stroke="#005450"
        stroke-width="0.5"
      />
    </svg>
  `,
})
export class SvgPreferredPharmacyComponent {
  @Input() color = '#000';
  @Input() backgroundColor = '#FFF';
  @Input() backgroundOpacity = 1;
  @Input() width = '100%';
  @Input() height = '100%';
}
